import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "videra-cookie-notice-ack";

// We set no analytics or advertising cookies, so this is a notice rather than a consent gate:
// there is nothing to refuse. Keep it that way, or this has to become a real consent manager.
export const CookieNotice = () => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    try {
      const ack = Number(window.localStorage.getItem(KEY));
      const year = 365 * 24 * 60 * 60 * 1000;
      if (!ack || Date.now() - ack > year) setShow(true);
    } catch {
      // Storage blocked — showing the notice every visit is the honest fallback.
      setShow(true);
    }
  }, []);

  const dismiss = () => {
    try {
      window.localStorage.setItem(KEY, String(Date.now()));
    } catch { /* nothing we can do, and nothing depends on it */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      data-testid="cookie-notice"
      className="fixed bottom-4 left-4 z-50 max-w-md rounded-sm border border-slate-700 bg-slate-900 p-4 text-slate-300 shadow-2xl"
    >
      <p className="pr-6 text-xs leading-relaxed">
        We use <strong className="font-semibold text-white">no analytics, advertising or tracking cookies</strong>.
        The only browser storage we set keeps you signed in and remembers your display choices.
      </p>
      <div className="mt-3 flex items-center gap-3">
        <button
          onClick={dismiss}
          data-testid="cookie-notice-accept"
          className="rounded-sm bg-white px-3 py-1.5 text-xs font-semibold text-slate-900 transition-colors hover:bg-slate-200"
        >
          Got it
        </button>
        <Link
          to="/legal/cookies"
          data-testid="cookie-notice-policy"
          className="text-xs font-medium text-slate-400 underline transition-colors hover:text-white"
        >
          Cookie policy
        </Link>
      </div>
      <button
        onClick={dismiss}
        aria-label="Dismiss cookie notice"
        data-testid="cookie-notice-close"
        className="absolute right-2 top-2 text-slate-500 transition-colors hover:text-white"
      >
        <X size={14} strokeWidth={1.5} />
      </button>
    </div>
  );
};
